import { Button } from "$components/button/button";
import { Box, Container, styled, Typography } from "@material-ui/core";
import { format, subMonths } from "date-fns";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import type { RegisterType } from "../../../__generated__/base.gql";
import { DATE_FORMAT } from "./constants";
import { DownloadDateFilters } from "./download-date-filters";
import { RegisterDownloadWarning } from "./register-download-warning";
import { useRequestDownload } from "./use-request-download";

const ButtonContainer = styled(Box)(() => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
}));

export const RequestRegisterDownloadPage = ({
  registerType,
}: {
  registerType: RegisterType;
}) => {
  const [startDate, setStartDate] = useState(
    format(subMonths(new Date(), 1), DATE_FORMAT),
  );
  const [endDate, setEndDate] = useState(format(new Date(), DATE_FORMAT));

  const [requestDownload] = useRequestDownload();

  return (
    <Container>
      <Box p={1} width="100%">
        <Container>
          <Box my={2}>
            <Typography variant="h3">
              <FormattedMessage
                id="register.requestDownload.title"
                defaultMessage="Download {registerType, select, 
                  ANC {ANC}
                  NigeriaDailyOutpatient {Daily Outpatient}
                  NigeriaGeneralAttendance {General Attendance}
                  GenericOPD {Patient}
                  other {}
                } Register"
                values={{ registerType }}
              />
            </Typography>
          </Box>
          <Box>
            <RegisterDownloadWarning />
            <DownloadDateFilters
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
            />
          </Box>

          <ButtonContainer>
            <Box>
              <Link color="secondary" to={".."} relative="path">
                <Button color="secondary">
                  <FormattedMessage
                    id="register.requestDownload.cancel"
                    defaultMessage="Cancel"
                  />
                </Button>
              </Link>
            </Box>
            <Button
              color="primary"
              onClick={() => {
                requestDownload({
                  variables: {
                    input: {
                      registerType,
                      filterOptions: { startDate, endDate },
                    },
                  },
                });
              }}
            >
              <FormattedMessage
                id="register.requestDownload.submit"
                defaultMessage="Download"
              />
            </Button>
          </ButtonContainer>
        </Container>
      </Box>
    </Container>
  );
};

export default RequestRegisterDownloadPage;
